// Common base types used across the application

export interface AuditFields {
  Created: string;
  CreatedBy: number;
  Modified?: string;
  ChangedBy?: number;
}

export interface StatusFields {
  Status: boolean;
}

export interface BaseEntity extends AuditFields, StatusFields {
  Id: number;
}

export interface BaseUser {
  Id: number;
  Name: string;
}

export interface ExtendedUser extends BaseUser {
  GivenName?: string;
  ExternalUserNo?: number;
  UserId?: string;
  CompanyNo?: number;
}

// Common enums used across multiple services
export enum EntityStatus {
  NotSet = 0,
  Active = 1,
  Inactive = 2,
  Closed = 3,
  Draft = 4,
  Solved = 5,
}

export enum CustomerTypeEnum {
  NotSet = 0,
  Normal = 1,
  Suspect = 2,
  Prospect = 3,
}

// Common request/response patterns
export interface PaginatedRequest {
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface PaginatedResponse<T> {
  items: T[];
  totalCount: number;
  pageSize: number;
  currentPage: number;
}

export interface ApiError {
  message: string;
  code?: string;
  details?: Record<string, unknown>;
}

export interface ApiResponse<T> {
  data: T;
  success: boolean;
  message?: string;
  error?: ApiError;
}